// const studyUtiva = "/";

export const programmes = [
  {
    id: "ai-automation",
    code: "AI",
    category: "AI",
    name: "AI Automation Diploma",
    outcome:
      "Build useful AI workflows, agents and automations for modern work.",
    level: "Beginner friendly",
    difficulty: "Foundation → Applied",
    duration: "12 weeks",
    format: "Live online",
    schedule: "Cohort timetable",
    nextCohort: "Check the next intake",
    status: "Admissions available",
    price: "See programme pricing",
    interests: ["data", "technology"],
    experiences: ["new", "some", "working", "career-change"],
    goals: [
      "first-job",
      "switch",
      "promotion",
      "portfolio",
      "freelance",
      "business",
    ],
    careerOutcomes: [
      "AI Automation Specialist",
      "Operations Analyst",
      "AI Workflow Builder",
    ],
    tools: ["Prompting", "AI agents", "Automation"],
    enrolUrl: "/courses/ai-automation-diploma",
    coursePageUrl: "/courses/ai-automation-diploma",
    communityName: "AI Community",
  },
  {
    id: "cybersecurity",
    code: "CY",
    category: "Cybersecurity",
    name: "Cybersecurity Bootcamp",
    outcome:
      "Learn to evaluate risk, protect systems and support security operations.",
    level: "Beginner friendly",
    difficulty: "Foundation → Applied",
    duration: "16 weeks",
    format: "Live online",
    schedule: "Cohort timetable",
    nextCohort: "Check the next intake",
    status: "Admissions available",
    price: "$350 on Study Utiva",
    interests: ["security"],
    experiences: ["new", "some", "working", "career-change"],
    goals: ["first-job", "switch", "promotion", "portfolio"],
    careerOutcomes: ["Cybersecurity Analyst", "SOC Analyst", "GRC Associate"],
    tools: ["Risk", "SOC tools", "Network security"],
    enrolUrl: "/courses/cybersecurity-bootcamp",
    coursePageUrl: "/courses/cybersecurity-bootcamp",
    communityName: "Cybersecurity Community",
  },
  {
    id: "data-analytics",
    code: "DA",
    category: "Data",
    name: "Data Analytics Bootcamp",
    outcome:
      "Turn business data into clear decisions and portfolio-ready dashboards.",
    level: "Beginner friendly",
    difficulty: "Foundation → Applied",
    duration: "6 months",
    format: "Live online",
    schedule: "Weekends",
    nextCohort: "Check the next intake",
    status: "Admissions available",
    price: "$200 on Study Utiva",
    interests: ["data"],
    experiences: ["new", "some", "career-change"],
    goals: ["first-job", "switch", "promotion", "portfolio", "freelance"],
    careerOutcomes: ["Data Analyst", "BI Analyst", "Reporting Analyst"],
    tools: ["Excel", "SQL", "Power BI"],
    enrolUrl: "/courses/data-analytics-bootcamp",
    coursePageUrl: "/courses/data-analytics-bootcamp",
    communityName: "Data Community",
  },
  {
    id: "data-science",
    code: "DS",
    category: "Data",
    name: "Data Science Bootcamp",
    outcome:
      "Analyse, visualise and predict with data through real-world projects.",
    level: "Beginner friendly",
    difficulty: "Foundation → Advanced",
    duration: "6 months",
    format: "Live online",
    schedule: "Weekends",
    nextCohort: "22 August 2026",
    status: "Cohort starting soon",
    price: "See programme pricing",
    interests: ["data"],
    experiences: ["some", "working", "career-change"],
    goals: ["switch", "promotion", "portfolio", "freelance"],
    careerOutcomes: ["Data Scientist", "Python Analyst", "ML Practitioner"],
    tools: ["Python", "SQL", "Power BI"],
    enrolUrl: "/courses/data-science-bootcamp",
    coursePageUrl: "/courses/data-science-bootcamp",
    communityName: "Data Community",
  },
  {
    id: "product-management",
    code: "PM",
    category: "Product",
    name: "Product Management & Design Bootcamp",
    outcome:
      "Move from problem discovery to a portfolio-ready digital product.",
    level: "Beginner friendly",
    difficulty: "Foundation → Applied",
    duration: "4 months",
    format: "Live online",
    schedule: "Weekends",
    nextCohort: "Check the next intake",
    status: "Admissions available",
    price: "See programme pricing",
    interests: ["products", "people"],
    experiences: ["new", "some", "working", "career-change"],
    goals: [
      "first-job",
      "switch",
      "promotion",
      "portfolio",
      "business",
      "leadership",
    ],
    careerOutcomes: ["Product Manager", "Associate PM", "Product Designer"],
    tools: ["Figma", "Jira", "Product strategy"],
    enrolUrl: "/courses/product-management-and-design-bootcamp",
    coursePageUrl: "/courses/product-management-and-design-bootcamp",
    communityName: "Product Community",
  },
  {
    id: "design",
    code: "UX",
    category: "Product",
    name: "Design Bootcamp",
    outcome:
      "Design useful, accessible digital experiences and build a strong portfolio.",
    level: "Beginner friendly",
    difficulty: "Foundation → Applied",
    duration: "See programme",
    format: "Project-based",
    schedule: "See programme",
    nextCohort: "Check the next intake",
    status: "Admissions available",
    price: "$120 on Study Utiva",
    interests: ["products"],
    experiences: ["new", "some", "career-change"],
    goals: ["first-job", "switch", "portfolio", "freelance"],
    careerOutcomes: ["Product Designer", "UI Designer", "UX Designer"],
    tools: ["Figma", "Research", "Prototyping"],
    enrolUrl: "/courses/product-management-and-design-bootcamp",
    coursePageUrl: "/courses/product-management-and-design-bootcamp",
    communityName: "Product Community",
  },
  {
    id: "business-analysis",
    code: "BA",
    category: "People & Business",
    name: "Business Analysis & Project Management",
    outcome:
      "Define problems, manage requirements and lead practical business change.",
    level: "Beginner friendly",
    difficulty: "Foundation → Applied",
    duration: "4 months",
    format: "Live online",
    schedule: "Weekends",
    nextCohort: "Check the next intake",
    status: "Next intake to be confirmed",
    price: "See programme pricing",
    interests: ["people", "products"],
    experiences: ["new", "some", "working", "career-change"],
    goals: ["first-job", "switch", "promotion", "portfolio", "leadership"],
    careerOutcomes: ["Business Analyst", "Project Coordinator", "PMO Analyst"],
    tools: ["Jira", "Agile methods", "Process mapping"],
    enrolUrl: "/courses/business-analysis-bootcamp",
    coursePageUrl: "/courses/business-analysis-bootcamp",
    communityName: "People & Business Community",
  },
  {
    id: "global-mba",
    code: "MBA",
    category: "Leadership",
    name: "Global MBA",
    outcome:
      "Build leadership, management and business capability with global partners.",
    level: "For professionals",
    difficulty: "Leadership",
    duration: "6 months",
    format: "Live online",
    schedule: "Cohort timetable",
    nextCohort: "Check the next intake",
    status: "Applications available",
    price: "See MBA pricing",
    interests: ["people", "growth", "products"],
    experiences: ["working"],
    goals: ["promotion", "business", "leadership"],
    careerOutcomes: ["Business Leader", "Functional Manager", "Founder"],
    tools: ["Leadership", "Finance", "Strategy"],
    enrolUrl: "/mba",
    coursePageUrl: "/mba",
    communityName: "Leadership Community",
  },
  {
    id: "frontend",
    code: "FE",
    category: "Software Development",
    name: "Frontend Development Bootcamp",
    outcome: "Build responsive interfaces and interactive web experiences.",
    level: "Beginner friendly",
    difficulty: "Foundation → Applied",
    duration: "See programme",
    format: "Practical online",
    schedule: "See programme",
    nextCohort: "Check the next intake",
    status: "Admissions available",
    price: "See programme pricing",
    interests: ["technology"],
    experiences: ["new", "some", "career-change"],
    goals: ["first-job", "switch", "portfolio", "freelance", "business"],
    careerOutcomes: ["Frontend Developer", "Web Developer", "UI Engineer"],
    tools: ["HTML", "CSS", "JavaScript"],
    enrolUrl: "/courses/frontend-development",
    coursePageUrl: "/courses/frontend-development",
    communityName: "Software Development Community",
  },
  {
    id: "fullstack",
    code: "FS",
    category: "Software Development",
    name: "Fullstack Development",
    outcome:
      "Build complete web products across frontend, backend and databases.",
    level: "Career pathway",
    difficulty: "Applied",
    duration: "See programme",
    format: "Practical online",
    schedule: "See programme",
    nextCohort: "Check the next intake",
    status: "Admissions available",
    price: "See programme pricing",
    interests: ["technology"],
    experiences: ["some", "working", "career-change"],
    goals: ["first-job", "switch", "portfolio", "freelance", "business"],
    careerOutcomes: [
      "Fullstack Developer",
      "Software Developer",
      "Web Engineer",
    ],
    tools: ["JavaScript", "APIs", "Databases"],
    enrolUrl: "/courses/fullstack-development",
    coursePageUrl: "/courses/fullstack-development",
    communityName: "Software Development Community",
  },
  {
    id: "cloud",
    code: "CL",
    category: "Cloud",
    name: "Cloud Bootcamp",
    outcome: "Deploy, migrate and monitor applications using Microsoft Azure.",
    level: "Beginner friendly",
    difficulty: "Foundation → Applied",
    duration: "15 weeks",
    format: "Live online",
    schedule: "Weekends",
    nextCohort: "22 August 2026",
    status: "Cohort starting soon",
    price: "See programme pricing",
    interests: ["infrastructure", "technology"],
    experiences: ["new", "some", "working", "career-change"],
    goals: ["first-job", "switch", "promotion", "portfolio"],
    careerOutcomes: [
      "Cloud Support Associate",
      "Cloud Developer",
      "Azure Associate",
    ],
    tools: ["Azure", "Cloud deployment", "Monitoring"],
    enrolUrl: "/courses/cloud-bootcamp",
    coursePageUrl: "/courses/cloud-bootcamp",
    communityName: "Cloud Community",
  },
  {
    id: "product-marketing",
    code: "GM",
    category: "Growth",
    name: "Product & Digital Marketing Bootcamp",
    outcome:
      "Build campaigns, positioning and go-to-market plans for digital products.",
    level: "Beginner friendly",
    difficulty: "Foundation → Applied",
    duration: "3 months",
    format: "Live online",
    schedule: "Weekends",
    nextCohort: "22 August 2026",
    status: "Cohort starting soon",
    price: "$400 full payment",
    interests: ["growth", "products"],
    experiences: ["new", "some", "working", "career-change"],
    goals: [
      "first-job",
      "switch",
      "promotion",
      "portfolio",
      "freelance",
      "business",
    ],
    careerOutcomes: [
      "Product Marketer",
      "Growth Associate",
      "Digital Marketer",
    ],
    tools: ["SEO", "Campaign analytics", "Go-to-market"],
    enrolUrl: "/courses/product-marketing-bootcamp",
    coursePageUrl: "/courses/product-marketing-bootcamp",
    communityName: "Marketing Community",
  },
  {
    id: "tech-sales",
    code: "TS",
    category: "Growth",
    name: "Tech Sales Pro Bootcamp",
    outcome:
      "Learn consultative selling, pipeline management and technology sales execution.",
    level: "Beginner friendly",
    difficulty: "Foundation → Applied",
    duration: "See programme",
    format: "Practical online",
    schedule: "See programme",
    nextCohort: "Check the next intake",
    status: "Admissions available",
    price: "See programme pricing",
    interests: ["growth", "people"],
    experiences: ["new", "some", "working", "career-change"],
    goals: ["first-job", "switch", "promotion", "freelance"],
    careerOutcomes: [
      "Sales Development Rep",
      "Account Executive",
      "Tech Sales Associate",
    ],
    tools: ["CRM", "Discovery", "Pipeline"],
    enrolUrl: "/courses/tech-sales-bootcamp",
    coursePageUrl: "/courses/tech-sales-bootcamp",
    communityName: "Growth Community",
  },
  {
    id: "hr-analytics",
    code: "HR",
    category: "People & Business",
    name: "Agile HR Analytics",
    outcome:
      "Use data to improve people decisions, talent management and HR operations.",
    level: "For HR professionals",
    difficulty: "Applied",
    duration: "3 months",
    format: "Live online",
    schedule: "Weekends",
    nextCohort: "Check the next intake",
    status: "Next intake to be confirmed",
    price: "See programme pricing",
    interests: ["people", "data"],
    experiences: ["some", "working", "career-change"],
    goals: ["promotion", "portfolio", "leadership"],
    careerOutcomes: [
      "HR Analyst",
      "People Analyst",
      "Talent Operations Analyst",
    ],
    tools: ["Excel", "People data", "Dashboards"],
    enrolUrl: "/courses/hr-analytics",
    coursePageUrl: "/courses/hr-analytics",
    communityName: "People & Business Community",
  },
];

export const interests = [
  {
    id: "data",
    label: "Build with data",
    description:
      "I like numbers, patterns and turning information into decisions.",
    symbol: "DATA",
  },
  {
    id: "products",
    label: "Build products",
    description:
      "I like solving problems and turning ideas into products people use.",
    symbol: "◆",
  },
  {
    id: "technology",
    label: "Build technology",
    description:
      "I want to build websites, applications and technology products.",
    symbol: "</>",
  },
  {
    id: "growth",
    label: "Grow businesses",
    description:
      "I enjoy customers, marketing, sales and helping companies grow.",
    symbol: "↗",
  },
  {
    id: "security",
    label: "Protect technology",
    description:
      "I am interested in cybersecurity, privacy and protecting digital systems.",
    symbol: "◎",
  },
  {
    id: "infrastructure",
    label: "Build infrastructure",
    description:
      "I am interested in cloud platforms and how modern technology runs.",
    symbol: "CLOUD",
  },
  {
    id: "people",
    label: "Work with people & business",
    description:
      "I enjoy operations, people, projects and improving how organisations work.",
    symbol: "PEOPLE",
  },
];

export const experiences = [
  {
    id: "new",
    label: "I'm completely new",
    description: "I am exploring tech and don't have experience yet.",
  },
  {
    id: "some",
    label: "I have some knowledge",
    description: "I've watched courses or tried learning this before.",
  },
  {
    id: "working",
    label: "I already work in this area",
    description: "I want stronger skills, projects and credentials.",
  },
  {
    id: "career-change",
    label: "I'm changing careers",
    description:
      "I have professional experience but want to move into something new.",
  },
];

export const goals = [
  { id: "first-job", label: "Get my first tech job" },
  { id: "switch", label: "Switch to a new career" },
  { id: "promotion", label: "Get promoted / add more value at work" },
  { id: "portfolio", label: "Build a portfolio" },
  { id: "freelance", label: "Start freelancing" },
  { id: "business", label: "Build my own business or product" },
  { id: "leadership", label: "Move into leadership" },
];

export const categories = [
  "All",
  "AI",
  "Data",
  "Product",
  "Software Development",
  "Cybersecurity",
  "Cloud",
  "Growth",
  "People & Business",
  "Leadership",
];

export const rankLabels = ["BEST MATCH", "GREAT ALTERNATIVE", "ALSO CONSIDER"];

export const testimonials = [
  {
    name: "Bankolé Adesina",
    role: "UX Designer",
    image: "/learner-portraits/bankole-adesina-v1.png",
    quote:
      "Utiva helped me refine my mindset and design process. I gained a deeper understanding of the thinking behind design.",
  },
  {
    name: "Chidera Robert",
    role: "Data Analytics learner",
    image: "/learner-portraits/chidera-robert-v1.png",
    quote:
      "I completed my first data analytics internship project, analysing payroll data with Excel for cleaning and visualisation.",
  },
  {
    name: "Olabode Kayode",
    role: "Data Science Engineer",
    initials: "OK",
    quote:
      "Data can feel advanced and complex until the right trainer makes it clear, practical and approachable.",
  },
];
